module.exports = __webpack_public_path__ + "static/media/drumset-boy.c5d6f7d8.png";